import { render, staticRenderFns } from "./SceneTrans.vue?vue&type=template&id=7996a9b1&scoped=true&lang=pug&"
import script from "./SceneTrans.vue?vue&type=script&lang=js&"
export * from "./SceneTrans.vue?vue&type=script&lang=js&"
import style0 from "./SceneTrans.vue?vue&type=style&index=0&id=7996a9b1&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7996a9b1",
  null
  
)

export default component.exports